import { useFoodpilotContext } from "src/context/FoodpilotContext";
import { QuestionnaireFormContextProvider } from "src/components/QuestionnaireForm/context/provider";
import { URLHandler } from "src/services/URLHandler";
import { getSsqDisplayTitleWithCampaign } from "src/utils/ssqTitle";
import { Loading } from "src/components/utils/Loading";
import { useGetIngredientPost } from "src/api/client-api/post/useGetIngredientPost";
import { QuestionnaireForm } from "src/components/QuestionnaireForm/layouts/QuestionnaireUpdateForm";
import { useParams } from "react-router";
import { useIngredientContext } from "../useIngredientContext";
import { useQuestionnaireUpdateScoresParams } from "src/components/QuestionnaireForm/useQuestionnaireUpdateScoresParams";
import { useIsProductUxV2 } from "src/hooks/useIsProductUxV2";

export const QuestionnaireUpdate = () => {
    const { ingredientId: ingredientIdParam } = useParams();

    const { selectedCompany, currentCampaign } = useFoodpilotContext();
    const { ingredient, activeCompanyId, ssqVersion, canModifySSQ } = useIngredientContext();
    const { scoresParams } = useQuestionnaireUpdateScoresParams();
    const isProductUxV2 = useIsProductUxV2();
    const appearance = isProductUxV2 ? "product-v2" : "legacy";

    const ingredientId = Number(ingredientIdParam);
    const postQuery = useGetIngredientPost({
        ingredientId: ingredientId,
        companyId: selectedCompany?.id,
        supplierId: activeCompanyId,
        campaignId: currentCampaign?.id,
        scoresQuery: scoresParams.query,
    });

    const ssq = ssqVersion?.ssq;

    if (!ingredient || !selectedCompany || !ssq) return <Loading appearance={appearance} />;

    const supplierId = activeCompanyId !== null ? activeCompanyId : undefined;

    return (
        <QuestionnaireFormContextProvider
            title={ingredient.name}
            subtitle={(ssq) => getSsqDisplayTitleWithCampaign(ssq, currentCampaign)}
            ssqVersion={ssqVersion}
            postQuery={postQuery}
            backUrl={URLHandler.ingredient.ssq(selectedCompany.id, ingredientId, supplierId)}
            getHeadingUrl={(headingId: number) =>
                URLHandler.ingredient.ssqHeading(selectedCompany.id, ingredientId, activeCompanyId ?? 0, headingId)
            }
            canEdit={canModifySSQ}
            appearance={appearance}
            ingredientReferenceId={
                (ingredient.referenceSource ?? "sure") === "sure" ? ingredient.ingredientReferenceId : undefined
            }
        >
            <QuestionnaireForm />
        </QuestionnaireFormContextProvider>
    );
};
